import React, { useContext, useMemo } from 'react';
import Dice from './Dice/Dice';
import NameContainer from './NameContainer/NameContainer';
import ReadyButton from './ReadyButton/ReadyButton';
import { PlayerDataContext } from '../../App';
import styles from './Navbar.module.css';

const STANDARD_VIEW_LAYOUT = [
    { seat: 'A', position: 'A' },
    { seat: 'C', position: 'C' },
    { seat: 'D', position: 'D' },
    { seat: 'B', position: 'B' },
];

const ABSOLUTE_SEAT_CLASS = {
    A: styles.seatA,
    B: styles.seatB,
    C: styles.seatC,
    D: styles.seatD,
};

const Navbar = ({
    playersBySeat = {},
    viewLayout = [],
    started,
    time,
    isReady,
    rolledNumber,
    nowMoving,
    movingPlayer,
    ended,
    moveSeqRef,
    viewerIsCreator = false,
    canCreatorStart = false,
    joinedPlayerCount = 0,
    minimumStartPlayers = 2,
}) => {
    const context = useContext(PlayerDataContext);

    const diceProps = {
        rolledNumber,
        nowMoving,
        movingPlayer,
        moveSeqRef,
    };

    const layoutToRender = useMemo(() => {
        // Trust the server-computed viewLayout (already viewer-relative for 2-player)
        if (Array.isArray(viewLayout) && viewLayout.length > 0) {
            return viewLayout;
        }
        return STANDARD_VIEW_LAYOUT;
    }, [viewLayout]);

    const renderPlayerContainer = (player, seatKey, fallbackKey, position) => {
        if (!player) return null;

        const className = ABSOLUTE_SEAT_CLASS[position] || '';
        const playerKey = player._id || `${seatKey}-${player.name || fallbackKey}`;

        return (
            <div className={`${styles.playerContainer} ${className}`} key={playerKey}>
                <NameContainer player={player} time={time} />
                {started && !ended && player.name !== '...'
                    ? <Dice playerColor={player.color} {...diceProps} />
                    : null}
                {context && context.color === player.color && !started
                    ? <ReadyButton
                        creatorStart
                        isCreator={viewerIsCreator}
                        canStart={canCreatorStart}
                        title={`${joinedPlayerCount}/${minimumStartPlayers} players joined`}
                      />
                    : null}
            </div>
        );
    };

    return (
        <>
            {layoutToRender.map((layoutItem, index) =>
                renderPlayerContainer(
                    playersBySeat[layoutItem.seat],
                    layoutItem.seat,
                    index,
                    layoutItem.position
                )
            )}
        </>
    );
};

export default Navbar;
